import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import React from 'react';

import Menu from './components/Menu';
import HomePage from './pages/HomePage';

import ChildrenIndexPage from './pages/Children/IndexPage';
import ChildrenNewPage from './pages/Children/NewPage';
import ChildrenShowPage from './pages/Children/ShowPage';
import ChildrenEditPage from './pages/Children/EditPage';

import CardsIndexPage from './pages/Cards/IndexPage';
import CardsNewPage from './pages/Cards/NewPage';
import CardsShowPage from './pages/Cards/ShowPage';
import CardsEditPage from './pages/Cards/EditPage';

import ProfileShowPage from './pages/Profile/ShowPage';
import ProfilePreviewPage from './pages/Profile/PreviewPage';

import AccountPage from './pages/AccountPage';

import LoginPage from './pages/LoginPage';
import LogoutPage from './pages/LogoutPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import RegisterPage from './pages/RegisterPage';
import CalendarPage from './pages/CalendarPage';
import TocPage from './pages/TocPage';

import { useAuthContext } from './providers/AuthContext';

import './index.css';
import './theme/variables.css';

import GaTracker from './components/GaTracker';

const App: React.FC = () => {
  const { user } = useAuthContext();

  return (
    <BrowserRouter>
      <GaTracker />
      <div className="flex min-h-screen bg-background text-foreground font-sans">
        {user && <Menu />}

        <div className="flex-1 flex flex-col min-h-screen">
          <Switch>
            {/* Public profile routes */}
            <Route path="/profile/:id" component={ProfileShowPage} exact />
            <Route path="/preview/:id" component={ProfilePreviewPage} exact />

            {/* Auth routes */}
            <Route path="/login" exact>
              <LoginPage />
            </Route>
            <Route path="/register" exact>
              <RegisterPage />
            </Route>
            <Route path="/forgot-password" exact>
              <ForgotPasswordPage />
            </Route>
            <Route path="/reset-password/:token" component={ResetPasswordPage} exact />
            <Route path="/logout" exact>
              <LogoutPage />
            </Route>
            <Route path="/toc" exact>
              <TocPage />
            </Route>

            {/* Authenticated routes */}
            <Route path="/home" exact>
              <HomePage />
            </Route>
            <Route path="/children" exact>
              <ChildrenIndexPage />
            </Route>
            <Route path="/children/new" exact>
              <ChildrenNewPage />
            </Route>
            <Route path="/children/:id/edit" component={ChildrenEditPage} exact />
            <Route path="/children/:id" component={ChildrenShowPage} exact />

            <Route path="/cards" exact>
              <CardsIndexPage />
            </Route>
            <Route path="/cards/new" exact>
              <CardsNewPage />
            </Route>
            <Route path="/cards/:id/edit" component={CardsEditPage} exact />
            <Route path="/cards/:id" component={CardsShowPage} exact />

            <Route path="/calendar" component={CalendarPage} exact />

            <Route path="/account">
              <AccountPage />
            </Route>

            <Route path="/" exact>
              <Redirect to={user ? "/children" : "/login"} />
            </Route>

            {/* Catch-all: redirect unmatched routes */}
            <Route>
              <Redirect to={user ? "/children" : "/login"} />
            </Route>
          </Switch>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default App;
